import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, setTitle, consoleLog} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';
import Blocks from './components/bbcode/blocks';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import PortalOverview from './components/overview/overview';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';

//import './css/index.css';
//import './css/header.css';

export default class Index extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			
			services: [],
			invite: [],
			invites: [],
			profile: {},
			discord: false,
		};
		this.getInvites = this.getInvites.bind(this);
		this.inviteStatus = this.inviteStatus.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		
		setTitle('Portal');

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/
		this.getInvites();
	}

	componentWillUnmount() {
	}

	async getInvites() {
		let params = new URLSearchParams();
		const x = await postApi('/v3/portal/index', params);
		consoleLog(x);
		if( x?.response?.status === 401 ) {
			window.location = '/';
		} else {
			this.setState({status: true, account: x.data.account, services: x.data.services, invite: x.data.invite?x.data.invite:[], invites: x.data.invites?x.data.invites:[], profile: x.data.profile?x.data.profile:{}, discord: x.data.discord?x.data.discord:false});
		}
	}

	async inviteStatus(service, id, status) {
		let params = new URLSearchParams();
		params.append('service', service);
		params.append('id', id);
		params.append('status', status);
		const x = await putApi('/v3/portal/invites', params);
		
		if( x.status === 200 ) {
			this.getInvites();
		}
	}
	

	render() {
		const user = this.context;

		let profile = Object.values(this.state.profile).filter(elem => elem === true);
		let profile_percent = profile.length / Object.values(this.state.profile).length * 100;
		//console.log(profile, profile_percent);

		const services = this.state.services.map((e,i) => {
			return (
				<PortalOverview key={i} service={e} version="mini" />
			)
		});

		
		const invite = this.state.invite.map((e,i) => {
			return (
				<Col md={6} key={i}>
					<div className="card custom-card">
						<div className="card-header">
							<div className="d-flex align-items-center w-100">
								<div className="me-2">
									<span className="avatar avatar-rounded">
										<img src={`https://cloud.ultrastream.io/images/${e.avatar}?d=${Math.floor(Date.now()/1000)}`} alt="img" />
									</span>
								</div>
								<div className="">
									<div className="fs-15 fw-semibold">{e.title}</div>
									<p className="mb-0 text-muted fs-11">{moment(new Date(e.mtime)).format("L  LT")}</p>
								</div>
								<div className="dropdown ms-auto">
									{e.status === 0 && <Button size="sm" variant="info" disabled={true}>Waiting Approval</Button>}
									{e.status === 1 && <Button size="sm" variant="success" disabled={true}>Invite Approved</Button>}
									{e.status === 2 && <Button size="sm" variant="danger" disabled={true}>Invite Declined</Button>}
								</div>
							</div>
						</div>
						<div className="card-body">
							<ol className="list-group list-group-numbered">
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Fullname:</div>
										{e.fullname?e.fullname:'Name not provided'}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Facebook Profile Page:</div>
										{e.facebook?e.facebook:'Facobook page not provided'}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">DJ'ing Experience:</div>
										{e.djing}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Broadcasting Experience:</div>
										{e.broadcasting}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Link to previous set:</div>
										{e.previous?e.previous:'Link to previous set not provided'}
									</div>
								</li>
							</ol>
						</div>
					</div>
				</Col>
			)
		});


		const invites = this.state.invites.map((e,i) => {
			return (
				<Col md={6} key={i}>
					<div className="card custom-card">
						<div className="card-header">
							<div className="d-flex align-items-center w-100">
								<div className="me-2">
									<span className="avatar avatar-rounded">
										<img src={`https://cloud.ultrastream.io/images/${e.avatar}?d=${Math.floor(Date.now()/1000)}`} alt="img" />
									</span>
								</div>
								<div className="">
									<div className="fs-15 fw-semibold">{e.title}</div>
									<p className="mb-0 text-muted fs-11">{moment(new Date(e.mtime)).format("L  LT")}</p>
								</div>
								<div className="dropdown ms-auto">
									{e.status === 0 &&
										<ButtonGroup size="sm">
											<Button variant="success" onClick={()=>this.inviteStatus(e.service, e.id, 1)}><FontAwesomeIcon icon="check" />&nbsp;Accept</Button>
											<Button variant="danger" onClick={()=>this.inviteStatus(e.service, e.id, 2)}><FontAwesomeIcon icon="xmark" />&nbsp;Decline</Button>
										</ButtonGroup>
									}
									{e.status === 1 && <Button size="sm" variant="success" disabled={true}>Invite Approved</Button>}
									{e.status === 2 && <Button size="sm" variant="danger" disabled={true}>Invite Declined</Button>}
								</div>
							</div>
						</div>
						<div className="card-body">
							<ol className="list-group list-group-numbered">
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Username:</div>
										{e.utitle?e.utitle:e.username}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Fullname:</div>
										{e.fullname?e.fullname:'Name not provided'}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Facebook Profile Page:</div>
										{e.facebook?e.facebook:'Facobook page not provided'}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">DJ'ing Experience:</div>
										{e.djing}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Broadcasting Experience:</div>
										{e.broadcasting}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Link to previous set:</div>
										{e.previous?e.previous:'Link to previous set not provided'}
									</div>
								</li>
							</ol>
						</div>
					</div>
				</Col>
			)
		});
		
		
		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Dashboard</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">

								<div className="row">
                <div className="col-xxl-12 col-xl-12">
                  <div className="card custom-card overflow-hidden">
                    <div className="card-body d-sm-flex align-items-top p-4   main-profile-cover">
                      <p className="avatar avatar-xxl avatar-rounded online me-3 my-auto">
                        
                          <img src={`https://cloud.ultrastream.io${this.state.account.avatar}`} width="100%" alt="Avatar" />
                        
                      </p>
                      <div className="flex-fill main-profile-info my-auto">
                        <h5 className="fw-semibold mb-1 ">
                          {this.state.account.title?this.state.account.title:this.state.account.username}
                        </h5>
                        <div>
                          {this.state.account.radios &&
                            <p className="mb-1 text-muted">{this.state.account.radios}</p>
                          }
                          {this.state.account.country &&
                            <div className="fs-12 op-7 mb-0 d-flex">
                                {typeof this.state.account.country === "string" ?
                                <p className="me-3 mb-0"><FontAwesomeIcon icon="building" /> {this.state.account.country}</p>
                                :
                                <>
                                    <p className="me-3 mb-0"><FontAwesomeIcon icon="building" /> {this.state.account.country[1]}</p>
                                    <p className="mb-0"><FontAwesomeIcon icon="location-dot" /> {this.state.account.country[0]}</p>
                                </>
                                }
                            </div>
                          }
                        </div>
                      </div>
                      <div className="main-profile-info ms-auto">
                        <div className="">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex mb-0 ms-auto">
                              <div className="me-4">
                                <p className="fw-bold fs-20  text-shadow mb-0">0</p>
                                <p className="mb-0 fs-12 text-muted ">Followers</p>
                              </div>
                              <div className="">
                                <p className="fw-bold fs-20  text-shadow mb-0">0</p>
                                <p className="mb-0 fs-12 text-muted ">Following</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-0  mt-2 text-end">
                          {(this.state.portable=== false && (user.user.admin || user.user.user.id === this.state.account.id)) &&
                            <><Link to={user.user.admin?`/settings/${this.state.account.username}`:'/settings'}><button type="button" className="btn btn-primary btn-sm btn-wave waves-effect waves-light"><FontAwesomeIcon icon="gear" /> Settings</button></Link>&nbsp;</>
                          }
                          <button type="button" className="btn btn-secondary btn-sm btn-wave waves-effect waves-light"><FontAwesomeIcon icon="plus" /> Follow</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
								</div>

								<Row>
									{invite}
									{invites}
								</Row>

								<Row>
									{profile_percent < 100 &&
										<Col md={6}>
											<div className="card custom-card border border-info">
												<div className="card-body">
													<div className="d-flex align-items-center">
														<div>
															<p className="card-text text-info mb-1 fs-14 fw-semibold">Profile {profile_percent}% complete.</p>
															<div className="card-title fs-12 mb-1">Continue to completing your profile setup</div>
															<div className="card-title text-muted fs-11 mb-0"><Link to={`/settings`}><Button size="sm">Settings</Button></Link></div>
														</div>
													</div>
												</div>
										</div>
										</Col>
									}
									{this.state.discord === true &&
										<Col md={6}>
											<div className="card custom-card border border-info">
												<div className="card-body">
													<div className="d-flex align-items-center">
														<div>
															<p className="card-text text-info mb-1 fs-14 fw-semibold">Connect Discord.</p>
															<div className="card-title fs-12 mb-1">One or more of your services use discord and would you like to connect to your discord account?</div>
															<div className="card-title text-muted fs-11 mb-0"><a href="https://discord.com/oauth2/authorize?client_id=1352061865815183370&response_type=code&redirect_uri=https%3A%2F%2Fportal.ultrastream.io%2Fauthentication%2Fdiscord&scope=identify" target="_blank" rel="noreferrer"><Button size="sm">Connect</Button></a></div>
														</div>
													</div>
												</div>
										</div>
										</Col>
									}
									<Col xs={12}></Col>
									{/*<Col xl={12}>
										<div className="card custom-card">
											<div className="card-body p-0">
												<div className="navbar navbar-expand-xxl bg-white">
													<a className="navbar-brand" href="javascript:void(0);">
														<img src="../assets/images/brand-logos/toggle-logo.png" alt="" className="d-inline-block align-text-top" />
													</a>
													<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
														<span className="navbar-toggler-icon"></span>
													</button>
													<div className="collapse navbar-collapse navbar-justified" id="navbarSupportedContent">
														<ul className="navbar-nav me-auto mb-2 mb-lg-0 align-items-xxl-center">
															<li className="nav-item">
																<a className="nav-link active" aria-current="page" href="javascript:void(0);">Pending (0)</a>
															</li>
															<li className="nav-item">
																<a className="nav-link" href="javascript:void(0);">Active (0)</a>
															</li>
															<li className="nav-item dropdown">
																<a className="nav-link" href="javascript:void(0);">Cancelled (0)</a>
															</li>
														</ul>
													</div> 
												</div>
											</div>
										</div>
									</Col>*/}
									{services}
									
								</Row>
							</div>

							

							{/*
							<Row>
								<Col xl={6}>
									<div className="card custom-card">
										<div className="card-header">
											<div className="card-title">
												Services
											</div>
										</div>
									</div>
								</Col>

							</Row>
							<div className="row">
								<div className="col-xl-6">
									<div className="card custom-card">
										<div className="card-header">
											<div className="card-title">
												Default alerts
											</div>
										</div>
										<div className="card-body">
											<div className="alert alert-primary" role="alert">
													A simple primary alert—check it out!
											</div>
											<div className="alert alert-secondary" role="alert">
												A simple secondary alert—check it out!
											</div>
											<div className="alert alert-success" role="alert">
												A simple success alert—check it out!
											</div>
											<div className="alert alert-danger" role="alert">
												A simple danger alert—check it out!
											</div>
											<div className="alert alert-warning" role="alert">
												A simple warning alert—check it out!
											</div>
											<div className="alert alert-info" role="alert">
												A simple info alert—check it out!
											</div>
											<div className="alert alert-light" role="alert">
												A simple light alert—check it out!
											</div>
											<div className="alert alert-dark" role="alert">
												A simple dark alert—check it out!
											</div>
										</div>
									</div>
								</div>
							</div>
							*/}
						</div>
					</div>
				}
			</>
		);
	}
}
